import FinancialTalkBubblesIcon from './FinancialTalkBubblesIcon'

export default FinancialTalkBubblesIcon
